module.exports = __webpack_public_path__ + "static/media/icon-supplies-conditioner.0c16be47.svg";